var React = require('react');

function LinkedinIconInline (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"m24.993424 26v-.0010958h.006576v-9.6454402c0-4.7186168-1.0159887-8.353464-6.5332345-8.353464-2.6523112 0-4.4322094 1.45525387-5.158855 2.8348959h-.0767197v-2.39437477h-5.2311908v17.55838307h5.4471021v-8.6942652c0-2.2891757.4340145-4.5027396 3.2693572-4.5027396 2.7936948 0 2.8353426 2.6124437 2.8353426 4.64958v8.5485206z","key":0}),React.createElement("path",{"d":"m0 9h5v17h-5z","key":1}),React.createElement("path",{"d":"m2.5 0c-1.38011797 0-2.5 1.11466068-2.5 2.48834398s1.11988203 2.51165602 2.5 2.51165602 2.5-1.13797272 2.5-2.51165602c-.00086745-1.3736833-1.12074948-2.48834398-2.5-2.48834398z","key":2})]);
}

LinkedinIconInline.defaultProps = {"height":"26","viewBox":"0 0 25 26","width":"25"};

module.exports = LinkedinIconInline;

LinkedinIconInline.default = LinkedinIconInline;
